import { useState } from 'react';
import { MenuItem, Stack } from '@mui/material';
import { FormTextField } from '../../../design-system';
import { preferredWorkflowDurationUnit, workflowDurationMinutes, workflowDurationUnits, type WorkflowDurationUnit } from '../models/workflowDuration';

/** API의 분 단위 값을 유지하며 사용자는 시간 단위를 선택합니다. */
export function WorkflowDurationField({ label, value, onChange, disabled, helperText }: {
  label: string;
  value: string;
  onChange: (minutes: string) => void;
  disabled?: boolean;
  helperText?: string;
}) {
  const [unit, setUnit] = useState<WorkflowDurationUnit>(() => preferredWorkflowDurationUnit(value));
  const displayed = value.trim() ? String(Number(value) / workflowDurationUnits[unit].multiplier) : '';
  const invalid = Boolean(value.trim()) && (!Number.isInteger(Number(value)) || Number(value) <= 0);
  return <Stack direction="row" spacing={1} sx={{ flex: 1, minWidth: 0, alignItems: 'flex-start' }}>
    <FormTextField label={label} type="number" value={displayed} disabled={disabled} onChange={(event) => onChange(workflowDurationMinutes(event.target.value, unit))}
      error={invalid} helperText={invalid ? '1분 단위의 양수를 입력해 주세요.' : undefined} help={helperText}
      slotProps={{ htmlInput: { min: 0, step: 'any' } }} fullWidth />
    <FormTextField select label={`${label} 단위`} hideLabel labelSuffix={<span aria-hidden="true">단위</span>} value={unit} disabled={disabled} onChange={(event) => setUnit(event.target.value as WorkflowDurationUnit)} sx={{ width: 100, flexShrink: 0 }}>
      {Object.entries(workflowDurationUnits).map(([key, option]) => <MenuItem key={key} value={key}>{option.label}</MenuItem>)}
    </FormTextField>
  </Stack>;
}
